'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reportImages = require('./reportImages.html');

var _reportImages2 = _interopRequireDefault(_reportImages);

var _reportImages3 = require('./reportImages.controller');

var _reportImages4 = _interopRequireDefault(_reportImages3);

require('./reportImages.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reportImagesComponent = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  template: _reportImages2.default,
  controller: _reportImages4.default,
  controllerAs: "vm"
};

exports.default = reportImagesComponent;


// WEBPACK FOOTER //
// ./client/app/common/reportImages/reportImages.component.js